import { render, staticRenderFns } from "./SandboxControl.vue?vue&type=template&id=80a9e688&"
import script from "./SandboxControl.vue?vue&type=script&lang=ts&"
export * from "./SandboxControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports